import axios from 'axios'
import HTTP from './http'

export default {
    getSiteContent: () => axios.get(HTTP.SITE_CONTENT),
    updateSiteContent: payload => axios.put(HTTP.SITE_CONTENT, { payload }),
    getSiteLngs: () => axios.patch(HTTP.SITE_CONTENT),
    deleteKey: payload => axios.post(HTTP.DLT_KEY_SITE_CONTENT, { payload }),
    deleteComp: id => axios.post(HTTP.DLT_COMP_SITE_CONTENT, { id }),
    addComp: payload => axios.post(HTTP.SITE_CONTENT_ADD, { payload })
}
